export default {
	common: {
		webName: 'MiraStudent',
		login: 'ログイン',
		startImmediately: '今すぐ始める',
		delete: '削除',
		experienceClass: '体験レッスン',
		enter: '入力してください',
		cancel: 'キャンセル',
		confirm: '確認',
		select: '選択してください',
		operationSuccessful: '操作成功',
		upload: 'アップロード',
		classID: 'クラスID',
		wantToDelete: '本当に削除しますか？',
		studyReport: '学習レポート',
		submit: '提出',
		userCenter: '個人センター',
		setting: '設定',
		updataSuccess: '提出成功、審査待ち',
		balance: 'Mira残高',
		simplifiedChinese: '簡体字中国語',
		traditionalChinese: '繁体字中国語',
		English: '英語',
		Japanese: '日本語',
		Korean: '韓国語',
		courseCancelled: 'コースがキャンセルされました',
		contactTeacher: '先生に連絡',
		numberClass: '{num}回のレッスン',
		endTime: '有効期限',
		setSuccess: '設定成功',
		studentsUpload: '学生アップロード',
		teacherUpload: '教師アップロード',
		hour: '時間',
		class: '回',
		fivetyminutes: '50分'
	},
	headers: {
		searchTeachers: '教師を検索',
		recommendTeachers: 'おすすめの教師',
		becomeTeacher: '教師になる',
		teacherPortal: '教師入口',
		balance: 'MIRA残高'
	},
	footers: {
		about: 'について',
		pavilionToUs: '私たちについて',
		used: '使い方',
		becomeTeacher: '教師になる',
		naturalResources: 'リソース',
		study: '学習コラム',
		help: 'ヘルプ',
		contactUs: 'お問い合わせ',
		questions: 'よくある質問',
		pay: '支払い方法',
		refund: '返金ポリシー',
		socialize: 'MiraStudent ソーシャル'
	},
	mainIndex: {
		titleOne: '1対1 専門教師',
		titleTwo: '個別指導・集中学習',
		titleThree: 'オンライン家庭教師プラットフォーム',
		titleFour: 'MiraStudentはオンライン家庭教師プラットフォームで、教育技術で地域と時間の制約を打破し、学生が自宅で',
		titleFive: '専門教師の指導を受けられるようにし、時間を節約し、学習効率と能力を向上させ、試験に簡単に対応できるようにします!',
		titleSubject: '人気の補習科目',
		viewMore: 'もっと見る',
		invitationalEducation: '学習潜在能力を引き出す教師を探す',
		introduce: '登録教師、専門科目教師、言語専門家、社会専門家がいて、さまざまな学習ニーズを解決します',
		reasonForSelection: 'MiraStudentを選ぶ理由',
		reasonTitleOne: '優れた教師陣',
		reasonContentOne: 'すべての教師は厳格な審査を経て、身元、経歴、学歴が確認されており、大部分は登録教師で専門科目の経験があります',
		reasonTitleTwo: '自由でリラックスした学習',
		reasonContentTwo: '従来のオフライン学習の枠組みを打破し、オンラインでいつでもどこでも授業を受けられ、通勤のストレスなく楽しく学習できます',
		reasonTitlethree: 'カスタマイズされた専用コース',
		reasonContentThree: '1対1の専門教師\nあなただけのユニークなコースを作成\n学習興味を育み、試験対応能力を向上させます',
		reasonTitlefour: '合理的で公平な料金',
		reasonContentFour: '授業料は教師が自由に設定するため、予算に合わせて適切な授業を選択できます。授業が満足できない場合は、残りの授業料を返金申請できます',
		classProcess: '授業の流れ',
		processOne_1: '適切な教師を見つける',
		processOne_2: '教師の経歴、自己紹介動画、学生評価を見て、適切な教師を選択します',
		processOne_3: '正式な授業の前に、教師とコミュニケーションを取り、「体験レッスン」を購入して教師との相性を試します',
		processTwo_1: '授業を予約',
		processTwo_2: '授業を購入後、教師のスケジュール表で空いている時間を予約し、確認を待ちます',
		processTwo_3: '学生は授業の24時間前までに予約を変更またはキャンセルできます',
		processThree_1: '授業開始',
		processThree_2: '学生は授業前にMTアカウントで教師のノート（ある場合）をダウンロードできます。授業時間になると、学生はコンピュータ、携帯電話、またはタブレットでMTアカウントからVOOVビデオ教室を開いて授業を受けることができます。授業終了後、課題がある場合、学生はMTアカウントからダウンロードして完了後、ウェブサイトに再度アップロードし、教師が採点するのを待ちます',
		obtainIncome: '学生と専門知識を共有して収入を得る',
		onlineTeaching: 'MiraStudentオンライン授業を開始するために登録',
		evaluate: 'MiraStudent学生の評価を聞く'
	},
	cashDesk: {
		cashRegister: 'レジ',
		goods: '商品',
		subject: '科目',
		category: 'カテゴリー',
		time: '時間',
		classNum: '授業回数',
		total: '小計',
		single: '単回',
		discount: '割引',
		selectCoupon: 'クーポンを選択',
		noCoupon: '選択しない',
		couponDiscount: '体験レッスン購入時に割引',
		totalCount: '合計金額',
		paymentMethod: '支払い方法',
		payment: 'MTコインを使用',
		balance: '残高',
		noBalance: '残高不足、クリックしてチャージ',
		pay: '確認して支払う',
		purchaseSuccessful: '購入成功'
	},
	forStudy: {
		skipQuestion: '質問をスキップ',
		chooseMentor: '自分で教師を選ぶ',
		studyFor: '何を学びたいですか？',
		budget: '授業あたりの予算は？',
		country: '国/地域は？',
		classTime: '授業時間は？',
		mentorLevel: '教師レベル？',
		motherTongue: 'ネイティブスピーカー？',
		masterLanguage: '同時に習得している言語？',
		weekMon_weekFri: '月曜日～金曜日',
		weekend: '土曜日、日曜日',
		anyTime: 'いつでも'
	},
	forClassIndex: {
		languageLevel: '言語レベル',
		onlineTeacher: 'オンライン英語教師',
		seacher: '教師名またはキーワードで検索',
		class: 'コース',
		pleaseSelect: '選択してください',
		budget: '授業あたりの学習予算',
		country: '出身国/地域',
		classTime: '授業時間',
		schedulingPeriod: 'スケジュール期間',
		mentorLevel: '教師レベル',
		brfore: '以前',
		motherTongue: 'ネイティブスピーカー',
		masterLanguage: '同時に習得している言語',
		suitable: '人のニーズに合った教師',
		new: 'NEW',
		highQualityMentor: '人の高品質教師',
		seniorTutor: 'ベテラン教師',
		professionalTeacher: '専門教師',
		professor: '教授',
		speek: '話せる',
		learnMore: '詳細を見る',
		minute: '分',
		poetryHall: '詩堂',
		trialClass: '体験レッスンを予約',
		contactMentor: '教師に連絡',
		viewClass: '完全な授業スケジュールを見る'
	},
	personalizationTeacher: {
		seacherTeacher: 'あなたに合った教師を見つける',
		hint: '1分かけて簡単な質問に答えると、最も適した教師をマッチングできます',
		studyFor: '学習の目的は何ですか？',
		start: '開始',
		selectTeacher: '自分で教師を選ぶ'
	},
	teacherVue: {
		information: '{name}についての情報',
		teachingSubjects: '教授科目',
		professorlevel: '教授レベル',
		highestEducationLevel: '最高学歴',
		experience: '特別教育ニーズの経験',
		aboutMe: '私について',
		videoIntroduction: 'ビデオ紹介',
		cannotPlay: 'ビデオ再生をサポートしていません',
		classTime: '授業時間',
		resume: '経歴',
		evaluate: '評価',
		myClass: '私の授業',
		testClassTime: '1回25分の授業',
		formalClasses: '正式な授業',
		formalClassTime: '{number}回50分の授業',
		priceAdjustment: '教師の授業料は{time}に調整されます'
	},
	login: {
		login: 'ログイン',
		welcome: 'MiraStudentへようこそ!',
		hint: '以下の方法でログインまたはアカウントを作成し、MiraStudentの利用規約とプライバシーポリシーに同意したことを示します。',
		loginMethod: '{way}でログイン',
		or: 'または',
		email: 'メールアドレス',
		emailAccount: 'メールアドレス',
		password: 'パスワード',
		passwordPlaceholder: 'パスワードを入力してください',
		forgotPassword: 'パスワードを忘れた',
		rememberMe: 'ログイン状態を保持',
		toLogin: 'ログイン',
		noAccount: 'まだアカウントをお持ちでないですか？',
		register: '登録',
		editPassword: 'パスワードを変更',
		retry: '{countdown}秒後に再試行',
		send: '確認コードを送信',
		code: '確認コード',
		codePlaceholder: '確認コードを入力してください'
	},
	studentsCom: {
		calendar: 'カレンダー',
		month: '月',
		week: '週',
		reportCourseNotCompleted: 'コース未完了を報告',
		situationDescription: 'コースが予定通りに完了しなかったことをお詫び申し上げます。以下の情報を正直に記入して状況を説明してください',
		whyNotCompleted: '*コースが完了しなかった理由は何ですか？',
		solution: '*期待する解決策は何ですか？',
		explanation: '説明と証明',
		explanationContent: 'リクエストをサポートする証拠がある場合は、最良の結果を得るためにできるだけ多く提供してください',
		uploadImage: '証拠として最大5枚の写真または動画をアップロード',

		myClass: '私の授業',
		bookNewClassroom: '新しいコースを予約',
		list: 'リスト',
		waitingClass: '授業待ち',
		completed: '完了',
		pendingConfirmation: '確認待ちのコース',
		enterClassroom: '教室に入る',
		upcomingCourses: '今後のコース',
		waitingConfirm: '教師の確認待ち',
		waitingConfirmstudent: '学生の確認待ち',
		confirmAfterClass: '授業後の確認待ち',
		confirmed: '確認済み',
		calendar: 'カレンダー',

		myWork: '私の課題',
		myNotes: '私のノート',
		myTeacher: '私の教師',
		reserve: '予約',
		chat: 'チャット',
		giveExtra: '追加贈与',
		recommendedTeacher: 'おすすめの教師',
		professionalTeacher: '専門教師',
		seniorTeacher: 'ベテラン教師',
		myTest: '私のテスト',

		resolved: '解決済み',
		selectSolutionTip: '学生と合意した解決策を選択し、提出後48時間以内に学生が確認します',
		selectSolution: '解決策を選択してください',
		selectPlaceholder: '選択してください',
		fillRefundAmount: '返金額を入力してください',
		feeDeductionTip: '授業料はまず返金額を差し引き、次に手数料を差し引き、残りは教師の財布に入ります',

		teacherEvaluation: '教師評価',
		classSatisfaction: '授業満足度',
		selectTeachingTraits: '教師{name}に適した教育特性タグを選択',
		showOnProfileNamed: 'この回答は教師のプロフィールページに表示されます（実名）',
		showOnProfileAnonymous: 'この回答は教師のプロフィールページに表示されます（匿名）',
		writeClassExperience: '授業体験を書く',
		classFeedback: '教師{name}への授業フィードバック',

		tradingOrder: '取引注文',
		completedOrders: '完了した注文',
		refundedOrders: '返金された注文',
		transactionTime: '取引時間',
		teacherName: '教師名',
		courseContent: 'コース内容',
		amount: '金額',
		orderNumber: '注文番号',

		unresolved: '未解決',
		uploadDataDecision: '証拠をアップロードしてプラットフォームが決定',
		explanationAndProof: '説明と証明',
		uploadEvidenceTip: 'リクエストをサポートする証拠がある場合は、最良の結果を得るためにできるだけ多く提供してください',
	},
	userMySetting: {
		setting: '設定',
		logOut: 'ログアウト',
		basicInfo: '基本情報',
		photo: '写真',
		uploadAvatarTip: '明確な個人プロフィール写真をアップロードしてください',
		name: '名前',
		inputNamePlaceholder: '名前を入力してください',
		gender: '性別',
		selectPlaceholder: '選択してください',
		male: '男性',
		female: '女性',
		timeZone: 'タイムゾーン',
		currency: '通貨',
		birthday: '誕生日',
		displayLanguage: '表示言語',
		country: '所在国',
		save: '保存',
		accountVerification: 'アカウント認証',
		email: 'メールアドレス',
		inputEmailPlaceholder: '入力してください',
		sendVerificationEmail: '認証メールを送信',
		password: 'パスワード',
		editPassword: 'パスワードを変更',
		bindApp: 'アプリを連携',
		facebook: 'Facebook',
		google: 'Google',
		wechat: 'WeChat',
		clickToBind: 'クリックして連携',
		unbind: '連携解除',
		confirmLogout: '本当にログアウトしますか？',
		logoutContent: 'ログアウト',
		confirm: '確認',
		cancel: 'キャンセル',
	},
	userMyWallet: {
		myWallet: '私の財布（学生）',
		recharge: 'チャージ',
		availableBalance: '利用可能残高',
		approximateAmountTip: '*ここに記載されている金額は概算であり、為替変動により多少の差が生じる可能性があります。すべての金額は米ドル建てです',
		walletTransactionDetails: '財布取引明細',
		time: '時間',
		item: '項目',
		amount: '金額',
		orderId: '注文ID',
		classNumber: '授業番号'
	},
	userCenter: {
		greeting: 'こんにちは！',
		nickname: 'ニックネーム',
		todolist: 'カレンダー',
		myCoursesPackage: '私のコースパッケージ',
		myCourses: '私のコース',
		classBalance: '授業残高',
		appointment: '予約',
		viewClass: '授業を見る',
		myCoupons: '私のクーポン',
		newUserCoupon: '新規ユーザー登録10元クーポン',
		minimumConsumption: '最低消費額',
		validTime: '利用可能時間',
		myHomework: '私の課題',
		completedHomework: '完了した課題',
		myTest: '私のテスト',
		noIncompleteTest: '未完了のテストはありません',
		learningReport: '学習レポート',
		personalizedRecommendation: 'パーソナライズされた推奨',
		todayHot: '本日のホット',
		fromUK: 'イギリス出身',
		nativeLanguage: '母国語',
		hourlyCharge: '時間あたりの料金',
		ticketPackage: 'チケットプラン',
		discount: '割引',
		recommendationReason: '推奨理由',
		bookNow: '今すぐ予約',
		toDoList: 'ToDoリスト',
		timeLimitedOffer: '期間限定オファー',
		purchase: '購入',
		remainingTime: '残り時間',
		teacherAppointmentConfirm: '教師が授業予約確認を送信',
		timeZone: 'タイムゾーン',
		confirm: '確認',
		reject: '拒否',
		reportContent: '件/最近3ヶ月',
	},
	appointment: {
		appointmentCourse: 'コースを予約',
		teacher: '教師',
		coursePackage: '授業パッケージ',
		remainingClasses: '残りの授業回数',
		selectedClasses: '選択済み',
		availableClasses: 'まだ選択可能',
		contactTool: '連絡ツール',
		selectContactTool: 'これらは教師が使用する連絡ツールです。連絡ツールを選択してください',
		nextStep: '次のステップ',
		cancel: 'キャンセル',
		confirm: '確認',
		reservationSuccess: '予約成功',
		appointmentClass: '授業回数を予約',
		classDate: '授業日',
		time: '時間',
		selectContact: '連絡方法を選択してください'
	},
	teacherConfirms: {
		week: '曜日',
		year: '年',
		month: '月',
		day: '日',
		utcTime: '(UTC+08:00)',
		classId: '授業ID:',
		language: '言語',
		duration: '期間',
		price: '価格',
		languageCategory: '言語カテゴリー',
		languageType: '言語タイプ',
		restTimeNote: '一部の教師は授業時間に5分間の休憩を含める場合があります。',
		contactTool: '連絡ツール',
		avatar: 'アバター会議ID',
		password: 'パスワード',
		teacherEntryTime: '教師が教室に入る時間:',
		studentEntryTime: '生徒が教室に入る時間:',
		notes: 'ノート',
		homework: '課題',
		test: 'テスト',
		uploadHomework: '課題をアップロード',
		uploadTest: 'テストをアップロード',
		pendingTeacherConfirm: '教師の確認待ち',
		yourClassPending: 'あなたの授業は教師の確認を待っています',
		cancelReschedulePolicy: 'キャンセルまたは再予約する場合は、まず当社の',
		pendingConfirm: '確認待ち',
		classPendingConfirm: '授業確認待ち',
		pendingClass: '授業待ち',
		classStartOnTime: 'あなたの授業は予約された時間に開始されます',
		classCompletedPendingConfirm: '完了した授業確認待ち',
		confirmWithin3Days: '授業終了後3日以内に確認してください。そうでない場合、システムは{time}({timeZone})に自動的に授業を確認します',
		reportClassNotCompleted: '授業が予定通りに終了しなかった場合は、「授業未完了」をクリックして報告できます。',
		completed: '完了',
		rateTeacherWithin3Days: '授業確認後3日以内に教師を評価してください',
		classCompletedCongrats: 'おめでとうございます。この授業は完了しました',
		classNotCompleted: '処理済みの授業',
		waitingTeacherProcess: '教師の処理待ち、教師は{time}({timeZone})までに処理します。',
		classNotCompletedResultConfirm: '授業未完了処理結果確認',
		processWithin48Hours: '48時間以内{time} ({timeZone})までに処理してください。',
		teacherSolution: '教師の処理方法:',
		refundAmount: '返金額:',
		agree: '同意',
		applyPlatformRuling: 'プラットフォーム裁定を申請',
		waitingPlatformRuling: 'プラットフォーム裁定待ち',
		pleaseWaitPlatform: 'プラットフォーム処理待ち',
		confirmClass: '授業を確認',
		cancelClass: '授業をキャンセル',
		enterClassroom: '教室に入る',
		interruptNote: '中断した場合は、このボタンを再度押して教室に入ってください',
		accomplishClass: '授業完了を確認',
		classNotAccomplished: '授業未完了',
		rateTeacher: '教師を評価',
		viewEvaluation: '評価を見る',
		confirmCancel: '本当にキャンセルしますか？',
		cancelClassText: '授業をキャンセル',
		confirmAction: '確認',
		cancelAction: 'キャンセル',
		operationSuccess: '操作成功',
		confirmAppointment: '本当に予約を確認しますか？',
		confirmAppointmentText: '予約を確認',
		enterClassroomText: '教室に入る',
		confirmCompletion: '本当に授業完了を確認しますか？',
		confirmCompletionText: '授業完了を確認',
		confirmDelete: '本当に削除しますか？',
		deleteText: '削除',
		confirmAgree: '本当に同意しますか？',
		agreeResultText: '処理結果に同意',
		confirmPlatformRuling: '本当にプラットフォーム裁定を申請しますか？',
		platformRulingText: 'プラットフォーム裁定を申請',
		policy: '《キャンセルと再予約ポリー》'
	},
	addClass: {
		addCourse: 'コースを追加',
		type: 'タイプ',
		pleaseSelect: '選択してください',
		courseName: 'コース名',
		classNumber: '授業回数',
		discount: '割引',
		teacherEarningsPerClass: '教師の収益/回あたり',
		displayPricePerClass: '表示価格/回あたり',
		noDiscount: 'なし',
		referenceMarketValue: '参考市場価値: 最低{currency}$80回、回あたり50分',
		cancel: 'キャンセル',
		save: '保存',
		confirmCancel: '本当にキャンセルしますか？',
		saveSuccess: '保存成功',
		popular: '人気'
	},
	classManage: {
		currentLevel: '現在のレベル',
		upgrade: '次のアップグレードまで{hour}時間',
		viewCommissionRatio: '手数料率を表示',
		priceAdjustmentNotice: '価格調整公示中',
		setClassTypeAndPrice: '授業タイプと価格を設定',
		trialClass: '体験レッスン',
		oneClass25Minutes: '1回25分の授業',
		save: '保存',
		addCourse: ' + コースを追加',
		confirmDelete: '本当に削除しますか？',
		deleteCourse: 'このコースを削除',
		submitSuccess: '提出成功、審査待ち',
		operationSuccess: '操作成功',
		cancel: 'キャンセル',
		effectiveTime: '有効時間',
		revokeModifications: '変更を元に戻す',
		setPrice: '価格を設定'
	},
	myClassTeacher: {
		myClassroom: '私の授業',
		waitingStudentConfirm: '学生の確認待ち',
		startingToday: '今日開始予定',
		waitingMyConfirm: '私の確認待ちの授業',
		futureClassroom: '今後の授業',
		completed: '完了',
		exception: '例外',
		confirmCancel: '本当にキャンセルしますか？',
		submitSuccess: '提出成功',
		operationSuccess: '操作成功',
		contactTools: '連絡ツール',
	},
	myStudents: {
		onCampusStudents: '在校生',
		archivedStudents: 'アーカイブされた学生',
		student: '学生',
		learnedCourse: '学習したコース',
		prepaidBalance: '前払い残高',
		remainingBalance: '残高',
		woXueZhiReport: 'Wo Xue Zhiレポート',
		communication: 'コミュニケーション',
		appointmentClass: '授業を予約',
		learningReport: '学習レポート',
		pleaseFill: '記入してください',
		operationSuccess: '操作成功',
		confirm: '確認',
		cancel: 'キャンセル',
		classHour: '授業時間'
	},
	resolved: {
		title: '解決済み',
		solutionInfo: '学生と合意した解決策を選択し、提出後48時間以内に学生が確認します',
		selectSolution: '*解決策を選択してください',
		pleaseSelect: '選択してください',
		none: 'なし',
		courseCompleted: 'コース完了',
		returnOnce: '1回返却',
		partialRefund: '部分返金',
		fillRefundAmount: '*返金額を入力してください',
		feeInfo: '授業料はまず返金額を差し引き、次に手数料を差し引き、残りは教師の財布に入ります',
		confirm: '確認',
		cancel: 'キャンセル',
		confirmResolve: '本当に解決しましたか？',
		resolveText: '解決',
		operationSuccess: '操作成功'
	},
	schedule: {
		teachingTime: '授業時間',
		availableTeachingTime: '利用可能な授業時間',
		addTimeSlot: '+時間帯を追加',
		generatedTeachingTime: '生成された利用可能な授業時間:',
		effectiveDate: '有効日',
		always: '常に',
		until: 'まで',
		save: '保存',
		confirmDelete: '本当に削除しますか？'
	},
	statistics: {
		total: '合計',
		netIncomeTotal: '純利益総額',
		unparticipatedTrials: '参加していない審判',
		tutoringHours: '指導時間',
		averageRating: '平均評価',
		totalRatings: '評価総数',
		totalStudents: '学生総数',
		averageClassRating: '平均授業評価',
		allCoursesStudentAvgRating: 'すべてのコースの学生平均評価',
		hoursPerStudent: '学生あたりの時間',
		calculationMethod: '指導時間を学生総数で割って計算されます。',
		attendanceStatus: '出席状況',
		annualPerformanceLast365Days: '過去365日間の年間パフォーマンス（最終更新日: 2025-02-07）',
		profileViews: 'プロフィール閲覧数',
		studentConversionRate: '学生への転換率',
		effectiveClassHours: '有効授業時間',
		hourlyRate: '時間あたりの料金',
		newStudents: '新しい学生',
		activeStudents: 'アクティブな学生',
		classHoursPerActiveStudent: 'アクティブな学生あたりの授業時間',
		trialClassRating: '体験レッスン評価',
		allTime: '全期間',
		thisMonth: '今月',
		thisWeek: '今週',
		downloadIncomeReport: '収益レポートをダウンロード'
	},
	teacherSet: {
		teacherAccountSetting: '教師アカウント設定',
		cloaking: 'ステルス',
		uncloaking: '非ステルス',
		setToCloaking: 'ステルスに設定',
		cancelCloaking: 'ステルスをキャンセル',
		teacherInfo: '教師情報',
		avatar: 'プロフィール写真',
		name: '名前',
		surname: '姓',
		speakLanguages: '話せる言語（複数選択可）',
		select: '選択してください',
		level: 'レベル',
		professorLevel: '教授レベル',
		specialEducationExperience: '特別教育経験',
		educationBackground: '学歴',
		certificate: '資格',
		synopsis: '一言紹介',
		selfIntroduction: '自己紹介',
		imageIntroduction: '画像紹介',
		video: 'ビデオ',
		uploadVideo: 'ビデオをアップロード',
		inputYoutubeLink: 'Paypalアカウントを入力',
		inputzhuanshukuai: 'FPSアカウントを入力',
		confirm: '確認',
		cancel: 'キャンセル',
		save: '保存',
		dataUnderReview: 'データ審査中、再提出しないでください...',
		paymentMethod: '支払い方法',
		paypal: 'Paypal',
		zhuanshukuai: 'FPS',
		contactTools: '連絡ツール',
		zoom: 'Zoom',
		meetingLink: '会議リンク',
		personalMeetingNumber: '個人会議番号(PMI)',
		meetingRoomPassword: '会議室パスワード',
		voov: 'VOOV',
		submitSuccess: '提出成功'
	},
	unresolved: {
		platformProcessing: '未解決申請提出後、プラットフォームが処理',
		unresolved: '未解決'
	},
	viewCommission: {
		commissionRatio: '手数料率',
		level: 'レベル',
		hours: '時間',
		mtExtraction: 'MT手数料',
		classCalculationNote: '50分の授業は1時間として計算、体験レッスンは含まれません',
		gotIt: 'わかりました'
	},
	wallet: {
		myWalletTeacher: '私の財布（教師）',
		withdraw: '引き出し',
		availableBalance: '利用可能残高',
		totalBalance: '総残高',
		pendingBalance: '保留中の残高',
		approximateAmountNote: '*ここに記載されている金額は概算であり、為替変動により多少の差が生じる可能性があります。すべての金額は米ドル建てです',
		walletTransactionDetails: '財布取引明細',
		withdrawalDetails: '引き出し明細',
		time: '時間',
		item: '項目',
		amount: '金額({currency})',
		courseId: 'コースID',
		status: '状態',
		cancelWithdrawal: '引き出しをキャンセル',
		myWalletTutor: '私の財布（教師）',
		transferToStudentWallet: '学生財布に転送',
		withdrawFromInternalAccount: '内部アカウントから引き出し',
		transferMethod: '転送方法',
		paypal: 'Paypal',
		fps: 'FPS',
		email: 'メール',
		enter: '入力してください',
		withdrawAmount: '引き出し金額',
		maxWithdraw: '最大引き出し可能額 {amount}{currency}',
		cancel: 'キャンセル',
		withdrawProfit: '利益を引き出し',
		transferToStudent: '学生財布に転送',
		confirm: '確認',
		operationSuccess: '操作成功',
		confirmCancel: '本当にキャンセルしますか？',
	},
	becomeTeacher: {
		becomeTeacher: '教師になる',
		fillPersonalInfo: '1 個人情報を記入',
		uploadPhoto: '2 写真をアップロード',
		uploadCertificate: '3 証明書をアップロード',
		fillEducation: '4 学歴を記入',
		fillIntroduction: '5 自己紹介を記入',
		uploadVideo: '6 ビデオをアップロード',
		fillTeachingTime: '7 授業時間を記入',
		fillTuition: '8 授業料を記入',
		startCreateProfile: '公開教師プロフィールの作成を開始します。各セクションを完了すると進行状況が自動的に保存されます。いつでも戻って登録を完了できます',
		name: '名前',
		pleaseFill: '記入してください',
		surname: '姓',
		speakLanguages: '話せる言語（複数選択可）',
		level: 'レベル',
		professorLevel: '教授レベル',
		specialEducationExperience: '特別教育経験',
		nextStep: '次のステップ',
		photo: '写真',
		previousStep: '前のステップ',
		certificate: '証明書',
		education: '学歴',
		synopsis: '一言紹介',
		selfIntroduction: '自己紹介',
		imageIntroduction: '画像紹介',
		inputYoutubeLink: 'YouTubeリンクを入力',
		confirm: '確認',
		teachingTime: '授業時間',
		availableTeachingTime: '利用可能な授業時間',
		addTimeSlot: '+時間帯を追加',
		generatedTeachingTime: '生成された利用可能な授業時間:',
		effectiveDate: '有効日',
		always: '常に',
		until: 'まで',
		setClassTypeAndPrice: '授業タイプと価格を設定',
		viewCommissionRatio: '手数料率を表示',
		trialClass: '体験レッスン',
		one25MinClass: '1回25分の授業',
		formalClass: '正式レッスン',
		addCourse: '+ レッスン追加',
		submit: '提出',
		submitSuccess: '提出成功、審査待ち',
		hint1: '名前を入力してください',
		hint2: '名字を入力してください',
		hint3: '使用可能な言語とレベルを選択してください',
		hint4: '教授レベルを選択してください',
		hint5: '特別教育経験を選択してください'
	},
	teacherIndex: {
		teacherCenter: '教師センター',
		myClass: 'マイレッスン',
		myStudents: 'マイ生徒',
		classManagement: 'レッスン管理',
		schedule: 'スケジュール',
		statistics: '統計',
		wallet: 'ウォレット',
		settings: '設定'
	},
	statusConfirms: {
		appointmentCourse: 'レッスン予約',
		teacher: '教師',
		coursePackage: 'レッスンパッケージ',
		remainingClasses: '残りレッスン回数',
		selectContactTool: '教師が使用する連絡ツールです。連絡ツールを選択してください',
		contactTool: '連絡ツール',
		nextStep: '次のステップ',
		confirmReservation: '予約確認',
		cancel: 'キャンセル',
		confirm: '確認',
		selectContactWay: '連絡方法を選択',
		reservationSuccess: '予約成功',
		week: '曜日',
		hoursFormat: '{start} / {end}',
		classId: 'レッスンID:',
		courseName: 'レッスン名',
		language: '言語',
		duration: '所要時間',
		price: '価格',
		languageCategory: '言語カテゴリ',
		languageType: '言語タイプ',
		breakNote: '一部の教師はレッスン時間に5分の休憩を含む場合があります',
		contactToolSection: '連絡ツール',
		meetingId: '会議ID',
		password: 'パスワード',
		teacherEntryTime: '教師の教室入室時間:',
		studentEntryTime: '生徒の教室入室時間:',
		notes: 'ノート',
		uploadNotes: 'ノートをアップロード',
		homework: '課題',
		uploadHomework: '課題をアップロード',
		test: 'テスト',
		uploadTest: 'テストをアップロード',
		waitingStudentConfirmClass: 'あなたのレッスンは生徒の確認待ちです',
		waitingStudentConfirm: '生徒確認待ち',
		waitingConfirm: '確認待ち',
		waitingClass: 'レッスン待機中',
		classCompletedConfirm: '完了レッスン確認待ち',
		classCompleted: '完了',
		classNotCompleted: '処理済みレッスン',
		studentConfirm: '生徒はレッスン終了後3日以内に確認します。未確認の場合、システムは{finish_time}({timeZone})に自動的にレッスンを確定します',
		studentMarkedNotCompleted: '生徒がレッスン未完了とマークしました。{time}({timeZone})までに対処してください',
		notCompletedReason: '{reason}のためレッスン未完了、{expectedResult}を希望',
		content: '{content}',
		resolved: '解決済み',
		unresolved: '未解決',
		waitingPlatformDecision: 'プラットフォーム判断待ち',
		confirmCourse: 'レッスンを確認',
		cancelClass: 'レッスンをキャンセル',
		enterClassroom: '教室に入る',
		reenterNote: '中断時は再入室',
		accomplishCourse: 'レッスン完了を確認',
		courseNotCompleted: 'レッスン未完了',
		confirmCancel: '本当にキャンセルしますか？',
		operationSuccess: '操作成功',
		cancelAndReschedulePolicy: '《キャンセル・再予約ポリー》',
		teacherhandlingplan: '教師の対応方法',
		refundAmount: '返金額',
		processWithin48Hours: '生徒の確認待ち。生徒は48時間以内{time}({timeZone})までに対処します',
		result1: 'レッスン完了済み',
		result2: '1回返還',
		result3: '部分返金'
	},
	classTime: {
		selectCourseStartTime: 'レッスン開始時間を選択({timeZone})',
		obtained: '取得済み',
		noCourse: 'レッスンなし'
	},
	introductionTeacher: {
		introduceTeacher: '教師紹介',
		recommendTeacherTip: '推薦教師のユーザー名を入力可能。プラットフォーム承認後、最初の3ヶ月間は推薦教師の稼働時間があなたの累計時間に加算されます',
		recommendTeacher: '教師を推薦',
		inputTeacherEmail: '教師のメールアカウントを入力',
		confirm: '確認',
		recommendedTeachers: '推薦済み教師',
		pendingReview: '審査待ち',
		close: '閉じる',
		operationSuccess: '操作成功'
	},
	recharge: {
		recharge: 'チャージ',
		rechargeAmount: 'チャージ金額',
		inputPrompt: '入力してください',
		thirdPartyFee: '第三者決済手数料（返金不可）+5%',
		totalPrice: '合計金額',
		cancel: 'キャンセル',
		submit: '提出',
		confirmRecharge: '本当にチャージしますか？',
		rechargeBalance: '残高をチャージ',
		rechargeSuccess: 'チャージ成功'
	}
}